<template>
  <div class="wrap">
    <car-headerbar :title="title" :isCustomLeft="isCustomLeft"/>
    <CarsForm
        v-if="($route.params.pageId && model.pageName) || !$route.params.pageId"
      ref="demoDynamicForm"
      :model="model"
      :configData="configData"
      @submitAction="submitAction"
    />
  </div>
</template>

<script>
import { Toast } from '@guazi-fe/melon'
import { Questionnaire } from '@/network'
import CarsForm from 'imc-mobile/src/component/form'
import { mixin } from '@/mixins'
// import { off as offStatus } from '@/util/status-util'
import browser from '@/util/browser'
import { addClass2, removeClass2 } from '@/util/status-util'
import debounce from '@/util/debounce'

export default {
    data() {
        return {
            isCustomLeft: false,
            active: 'home',
            title: '创建问卷',
            model: {
                pageName: '',
                pageComment: '',
            },
            configData: {
                form: {
                    button: { disabled: false, text: '确定', api: 'submit' },
                    groupData: [{
                        code: 'pageName',
                        label: '问卷名称',
                        type: 'text',
                        rules: [{ required: true, message: '请填写问卷名称' }],
                        props: {
                            maxlength: '50',
                            showWordLimit: true,
                        },
                    }],
                },
                api: {
                    request: {
                        submit: {
                            url: '',
                            method: 'post',
                        },
                    },
                },
            },
            options: {
                props: { // 表单props配置
                    'validate-first': true,
                    'scroll-to-error': true,
                    'show-error-message': false,
                },
                controls: [],
            },
        }
    },
    components: {
        CarsForm,
    },
    mixins: [mixin],
    created() {
        if (this.$route.params.pageId) {
            this.initForm()
        } else {
            removeClass2('body', 'loading')
        }
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
        // setTimeout(()=>{
        //     $CA.util.NativeAPI.invoke('hiddenCloseBtn',{"hiddenClose":"1"})
        // })
    },
    methods: {
        initForm() {
            addClass2('body', 'loading')
            this.title = '编辑问卷'
            this.configData.form.groupData.push({
                code: 'pageComment',
                label: '问卷说明',
                type: 'textarea',
                rules: [{ required: false, message: '请填写问卷说明' }],
                props: {
                    maxlength: '500',
                    showWordLimit: true,
                    rows: 5,
                },
            })
            Questionnaire.getQuestionInfo({
                tid: this.tid,
                pageId: this.$route.params.pageId,
            }).then((res) => {
                // offStatus('loading')
                removeClass2('body', 'loading')
                const { code, data } = res.data
                if (code == 'S00000') {
                    //  没有deep watch
                    // console.log(data.pageName, 111)
                    this.model = {
                        pageName: data.pageName,
                        pageComment: data.pageComment,
                    }
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                Toast.fail(error.response.data.message)
            })
        },
        submitAction: debounce(function (res) {
            addClass2('body', 'loading')
            const data = {
                tid: this.tid,
                pageName: res.pageName,
                pageComment: res.pageComment,
            }
            let questionApi = 'questionCreate'
            if (this.$route.params.pageId) {
                data.pageId = this.$route.params.pageId
                questionApi = 'questionEdit'
            }
            // questionEdit todo
            Questionnaire[questionApi](data).then((res) => {
                if (res.data.code == 'S00000') {
                    let pageId
                    if (this.$route.params.pageId) {
                        pageId = this.$route.params.pageId
                    } else {
                        pageId = res.data.data.pageId
                    }

                    const { guaguaApp } = browser

                    if (guaguaApp && this.$route.params.pageId) { // 是否是编辑
                        let lastPage = window.location.href
                        window.history.back()
                        setTimeout(() => {
                            if (window.location.href !== lastPage) {
                            } else {
                                $CA.util.NativeAPI.invoke('closeCurrentWebView', null, () => {})
                            }
                        }, 300)
                    } else {
                        this.$router.replace({
                            name: 'edit',
                            params: {
                                pageId: pageId,
                            },
                        })
                    }

                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                Toast.fail(error.response.data.message)
            }).catch((error) => {
                removeClass2('body', 'loading')
                console.error(error)
            })
        }, 800),
    },
}
</script>
<style lang="scss" scoped>
    .wrap{
        position: relative;
        height: 100%;
    }

    ::v-deep .dynamic-form-container{
        padding: 0;
        background: #fff;
        .dynamic-form-fielditem{
            .me-cell__title{
                font-size: 14px;
                font-weight: bold;
                color:#222;
            }
            .me-field__body{
                // .me-field__control{
                    input,textarea {
                        background: #F6F6F6;
                        line-height: 36px;
                        border-radius: 6px;
                        padding-left: 16px ;
                    }
                    input[readonly="readonly"]{
                        display: none
                    }
                // }
            }
            .me-field--min-height .me-field__control{
                min-height: 36px;
            }
        }

        .dynamic-form-footer{
            .me-button--primary{
                background: #06B455;
            }
        }
    }
    ::v-deep .textarea-wrap .me-field__control{
        height: calc(100vh - 8rem);
    }
</style>
